// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1ENHK","upload":"Small_upload__3Z_cR","imageWrap":"Small_imageWrap__2Wb1h","removeBtn":"Small_removeBtn__O1pRK"};